import { AccountType, UserActivityType } from 'config'

export interface IActiveUser {
  accountType: AccountType
  count: string
  email: string
  id: number
}

export interface IUserActivity {
  action: string
  createdAt: string
  detail: Record<string, any>
  id: number
  loanNumber: number
  type: UserActivityType
  updatedAt: string
  userId: number
  userEmail?: string
  userAccountType?: string
}

export const ALL_USERS_ID = 0
